import { privateApi } from "../../api";

export const createExportAssetExpense = async (inputData) => {
    return await privateApi.post('exportAssetExpense/create', inputData);
};

export const getExportAssetExpenses = async (query) => {
    // Remove empty strings and undefined values from query params
    const cleanQuery = {};
    Object.keys(query).forEach(key => {
        if (query[key] !== '' && query[key] !== undefined && query[key] !== null) {
            cleanQuery[key] = query[key];
        }
    });
    // Build query string manually to avoid axios params wrapping issue
    const queryString = new URLSearchParams(cleanQuery).toString();
    const url = queryString ? `exportAssetExpense/getExpenses?${queryString}` : 'exportAssetExpense/getExpenses';
    return await privateApi.get(url);
};

export const getExportAssetExpensesForExport = async (query) => {
    // Remove empty strings and undefined values from query params
    const cleanQuery = {};
    Object.keys(query).forEach(key => {
        if (query[key] !== '' && query[key] !== undefined && query[key] !== null) {
            cleanQuery[key] = query[key];
        }
    });
    // Build query string manually to avoid axios params wrapping issue
    const queryString = new URLSearchParams(cleanQuery).toString();
    const url = queryString ? `exportAssetExpense/getExpensesForExport?${queryString}` : 'exportAssetExpense/getExpensesForExport';
    return await privateApi.get(url);
};

export const updateExportAssetExpense = async (id, inputData) => {
    return await privateApi.put(`exportAssetExpense/update/${id}`, inputData);
};

export const deleteExportAssetExpense = async (id) => {
    return await privateApi.delete(`exportAssetExpense/delete/${id}`);
};

export const getBalance = async () => {
    return await privateApi.get('exportAssetExpense/getBalance');
};

export const updateBalance = async (balance) => {
    return await privateApi.put('exportAssetExpense/updateBalance', { balance });
};

// Category endpoints
export const getCategories = async () => {
    return await privateApi.get('exportAssetExpenseCategory/getCategories');
};

export const createCategory = async (name) => {
    return await privateApi.post('exportAssetExpenseCategory/create', { name });
};

